import NotificationContainer from "./NotificationContainer";
import NotificationStore from "./NotificationStore";
export default NotificationStore(NotificationContainer);